module.exports = __webpack_public_path__ + "media/images/common/lp/icon-comment-26e2008d2ae240ab7f697e385661f0ae.png";